import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/cultura' };
/////////////////////////////////////////////////////////////////////////////////

export function createCulturaCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateCulturaCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listCulturaCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findCulturaCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllCulturaCadastro() {
  return httpService.get({ ...args, path: '/cultura/all' });
}

export function deleteCulturaCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

